var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon)?_c('gl-icon',_vm._b({directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip",value:(_vm.icon.tooltip),expression:"icon.tooltip"}],attrs:{"aria-label":_vm.icon.tooltip,"name":_vm.icon.name}},'gl-icon',_vm.$attrs,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }